export const person = [
  {
    path: '/person',
    component: () => import(/* webpackChunkName: "person" */ '@/views/person/Person'),
    children: [
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "person" */ '@/views/person/components/PersonEditBody'),
      },
      {
        path: ':id/edit',
        component: () => import(/* webpackChunkName: "person" */ '@/views/person/components/PersonEditBody'),
      },
      {
        path: ':id/picture',
        component: () => import(/* webpackChunkName: "person" */ '@/views/person/components/PersonPictureBody'),
      },
      {
        path: ':id/participations',
        component: () => import(/* webpackChunkName: "person" */ '@/views/person/components/PersonParticipationsBody'),
      },
      {
        path: ':id/funding',
        component: () => import(/* webpackChunkName: "person" */ '@/views/person/components/PersonFundingBody'),
      },
    ]
  },
]
